import axios from "axios";
import { clearLocalStorage, getLocalStorage, resetNavigation } from "../Functions/Utils";
import { Message } from "@arco-design/web-react";

export const GET_API = async (path, params, headers = "") => {
  // var config = { method: "get", url: baseUrl + path, headers: { key: headers } };
  var config = headers
    ? {
      method: "get",
      url: global.uploadData + path + params,

      headers: {
        key: headers,
        Authorization: "Bearer " + getLocalStorage("access_token"),
      },
    }
    : {
      method: "get",
      url: global.uploadData + path + params,
      headers: {
        Authorization: "Bearer " + getLocalStorage("access_token"),
      }
    };
  //

  // //console.log("GET API response", { config });
  let response = await axios(config)
    .then(function (response) {
      // //console.log("GET API response", response.config);

      return response;
    })
    .catch(function (error) {
      // //console.log("GET API error", error);
      if (error.response) {
        return error.response;
      } else {
        return { status: 503, message: "NetWork Error !" };
      }
    });

  return ResponseValidation(response, config);
};
//post method calling function
export const POST_API = async (data, headers, path) => {
  let url = '';
  var config =''

  if(path.includes('canadian_dl')){
    url = `${path}`;
    config = {
      method: 'post',
      url: url,
      data: data,
      headers: {
        Key: global.canadianDL_header,

      },
    };
  }else if(path.includes('dynamic-ovd-extractor')){
    url = `${path}`;
    config = {
      method: 'post',
      url: url,
      data: data,
      headers: {
        Key: global.dynamicovd_header,

      },
    };
  }
  else if(path.includes('medical-prescription-ocr')){
    url = `${path}`;
    config = {
      method: 'post',
      url: url,
      data: data,
      headers: {
        Key: global.MEDICALREPORTHEADER,

      },
    };
  }
  else if(path.includes('prescription-ocr')){
    url = `${path}`;
    config = {
      method: 'post',
      url: url,
      data: data,
      headers: {
        Key: global.prescription_ocr_header,

      },
    };
  }
  else if(path.includes('UAEVisa')){
    url = `${path}`;
    config = {
      method: 'post',
      url: url,
      data: data,
      headers: {
        Key: global.UAEVISAOCRHEADER,
      },
    };
  }
  else{
    url = `${global.uploadData}${path}`;
    if (headers) {
      headers.Authorization = "Bearer " + getLocalStorage("access_token")
    }
    config = headers
    ? {
      method: 'post',
      url: url,
      headers: headers,
      data: data,
    }
    : {
      method: 'post',
      url: url,
      data: data,
      headers: {
        Authorization: "Bearer " + getLocalStorage("access_token"),

      }
    };
  }

  //console.log('POST API config', config);
  // ""
  try {
    const response = await axios(config);

    // //console.log(ResponseValidation(response)); // Assuming ResponseValidation is a function defined elsewhere
    return ResponseValidation(response);
  } catch (error) {
    // console.error('POST API error', error,error?.response?.status);
    if (error.response) {
      let errorData = { status: error?.response?.status, data: error?.response?.data }

      return ResponseValidation(errorData);
    } else {
      return { status_code: 503, message: 'Network Error!' };
    }
  }
};

//api response validate function

export const ResponseValidation = async (response) => {
  let status_code = null;
  let response_data = null;
  let message = null;
  if (response) {
    if (response.status) {
      // //console.log("res status", response.status);
      if (response.status === 200) {
        message = "Success";
        status_code = response.status;
        response_data = response.data;
      } else if (response.status === 401) {
        // //console.log({ response });
        //  Message.error("Session Expired. Please log in again to continue");

        status_code = response.status;
        response_data = 0;
        await clearLocalStorage();

        setTimeout(() => {
          resetNavigation("/");
        }, 1000);
      } else if (response.status === 404) {
        message = "Page Not found";
        status_code = response.status;
        response_data = 0;
        // //console.log(JSON.stringify(response_data));
      } else if (response.status === 406) {
        message = "No visible text in page";
        status_code = response.status;
        response_data = 0;
        // //console.log(JSON.stringify(response_data));
      } else if (response.status === 403) {
        message = "Not Authenticated'";
        status_code = response.status;
        response_data = 0;
        // //console.log(JSON.stringify(response_data));
      } else if (response.status === 400) {
        message = "Bad Request!";
        status_code = response.status;
        response_data = response.data;
        // //console.log(JSON.stringify(response_data));
      }
      else if (response.status === 500) {
        message = "Internal Server Error";
        status_code = response.status;
        response_data = 0;
      } else if (response.status === 503) {
        message = "Seems like server is not running";
        status_code = response.status;
        response_data = 0;
      }else if (response.status === 429) {
        message = "Too Many Requests";
        status_code = response.status;
        response_data = 0;
      } else {
        message = "Unhandled Condition met";
        response_data = 0;
        const response_message = JSON.stringify(response.data);
        status_code = 422;
      }

      return { response_data, message, status_code };
    } else {
      message = "unexpected response got";
      // //console.log("Response validation - No response status", response);
      status_code = 422;

      return { status_code, message };
    }
  }
};
